<template>
  <el-popover
      v-model="visible"
      :placement="placement"
      width="200"
      @show="warning = true">
    <div
        v-if="warning">
      <h3 style="text-align: center;">
        Warning
      </h3>
      <div style="word-break: auto-phrase; width: 180px; text-align: center; margin: 12px">
        Inform Neighbor that running a throughput test will pause device recordings, including 24/7 recording.
        Functionality will resume once test is complete.
      </div>
      <div style="text-align: right; margin: 0">
        <el-button
            size="mini"
            type="text"
            @click="visible = false">
          cancel
        </el-button>
        <el-button
            :disabled="running"
            type="primary"
            size="mini"
            @click="warning = false">
          <span>
            <i
                v-show="running"
                class="el-icon-loading"></i>
            continue
          </span>
        </el-button>
      </div>
    </div>

    <div
        v-else>
      <div style="margin: 17px">
        <el-checkbox
            v-for="(_, key) in throughput.test_settings"
            :key="key"
            v-model="throughput.test_settings[key].bool"
            style="display: block; margin: 0;"
            disabled
            @change="switchSetting(key)">
          {{ startCase(key) }}
        </el-checkbox>
      </div>
      <div style="text-align: right; margin: 0">
        <el-button
            size="mini"
            type="text"
            @click="visible = false">
          cancel
        </el-button>
        <el-button
            :disabled="running"
            type="primary"
            size="mini"
            @click="run">
          <span>
            <i
                v-show="running"
                class="el-icon-loading"></i>
            run
          </span>
        </el-button>
      </div>
    </div>

    <section slot="reference">
      <slot>
        <el-button
            type="text">
          Throughput Test
        </el-button>
      </slot>
    </section>
  </el-popover>
</template>

<script>
import { find, get, keys, startCase } from "lodash";
import { createNamespacedHelpers as h } from "vuex";
const { mapGetters: sharedGetters } = h("shared");

export default {
  name: "ThroughputTest",
  props: {
    placement: {
      type: String,
      default: "bottom",
    },
    deviceKind: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      warning: true,
      visible: false,
      possible_throughput_tests: {
        iperf_tcp: 1,
        iperf_udp_1M: 2,
        iperf_udp_2M: 4,
        iperf_udp_4M: 8,
        ping: 16,
        channel_score: 32,
        egress_test_on_demand: 64,
        fast_ping_test_on_demand: 128,
      },
      throughput: {
        value: 0,
        test_settings: {},
      },
      running: false,
    };
  },
  computed: {
    ...sharedGetters(["products"]),
  },
  mounted() {
    const product = this.getProduct(this.deviceKind);
    const optionThroughputTest = get(product, "options.throughput_test", {});

    let throughputTests = Object.keys(optionThroughputTest).filter(
      (key) => optionThroughputTest[key] == true
    );
    var curr_context = this;
    throughputTests.forEach(function (test_type) {
      if (test_type === "egress") {
        test_type = test_type + "_test_on_demand";
      }
      if (test_type === "fastping") {
        test_type = "fast_ping_test_on_demand";
      }
      curr_context.throughput.test_settings[test_type] = {
        int: curr_context.possible_throughput_tests[test_type],
        bool: true,
      };
    });
    this.throughput.value = Math.pow(2, throughputTests.length) - 1;
  },
  methods: {
    startCase,
    switchSetting(setting) {
      const settings = keys(this.throughput.test_settings);
      const exists = !!find(settings, (el) => el === setting);
      if (!exists) {
        throw new Error("Throughput Test Setting Does Not Exist");
      }
      const s = this.throughput.test_settings[setting];
      this.throughput.value += s.bool ? +s.int : -s.int;
    },
    run() {
      this.running = true;
      const done = () => {
        this.visible = false;
        this.running = false;
      };
      this.$emit("execute", this.throughput.value, done);
    },
    getProduct(productKind) {
      return (
        this.products.find((product) => product.kind === productKind) || {}
      );
    },
  },
};
</script>

<style scoped></style>
